module.exports = __webpack_public_path__ + "static/media/backsplash.fff1eb54.jpg";